module.exports = __webpack_public_path__ + "img/mobileTerminalCode.53199774.jpg";